import { BillingAddress } from '@buy/state/get-address/state'
import { GetTaxDetailsResponseBody } from '@buy/state/get-tax-details/state'
import { ExistingBillingInfoType } from '@common/state/user/state'

export const processExistingBillingInfoUCS = (data: BillingAddress, taxDetails: GetTaxDetailsResponseBody) => {
    const processedBillingData: ExistingBillingInfoType = {
        accountType: '', // data.accountType || '', // Doesn't seem to be used in form-submission-ucs.ts
        addressLine1: data.addressLine1 || '',
        addressLine2: data.addressLine2 || '',
        anniversaryDate: '', // data.anniversaryDate || '', // Doesn't seem to be used in form-submission-ucs.ts
        city: data.city || '',
        companyName: data.companyName || '',
        country: data.country || '',
        email: data.email || '',
        federalTaxType: taxDetails.subTaxNumberType || '',
        firstName: data.firstName || '',
        hasInAppSubscription: false, // !!data.hasInAppSubscription // Doesn't seem to be used in form-submission-ucs.ts
        lastName: data.lastName || '',
        paymentAccountKey: '', // data.paymentAccountKey || '' // Doesn't seem to be used in form-submission-ucs.ts
        phoneNumber: data.phoneNumber || '',
        postalCode: data.postalCode || '',
        state: data.state || '',
        status: '', // data.status || ''
        taxNumber: taxDetails.taxNumber || '',
    }
    return processedBillingData
}
